import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import OurPractices from '../components/OurPractices';
import WhyChooseUs from '../components/WhyChooseUs';
import OurValues from '../components/OurValues';
import PartnerWithUs from '../components/PartnerWithUs';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <>
      <Navigation />
      <Hero />
      <Mission />
      <OurPractices />
      <WhyChooseUs />
      <OurValues />
      <PartnerWithUs />
      <Footer />
    </>
  );
}

export default HomePage;
